<template>
  <td>
    <span v-if="content === true">IN</span>
    <span v-else-if="content === false">OUT</span>
    <span v-else>C2C</span>
  </td>
</template>

<script>
export default {
  props: ["content"]
};
</script>
